var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blue_plus.svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3fcaea;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-width: 3px;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_543_copy",
    "data-name": "Ellipse 543 copy",
    className: "cls-1",
    cx: 15.5,
    cy: 15.5,
    r: 15.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_545_copy",
    "data-name": "Shape 545 copy",
    className: "cls-2",
    d: "M2023,5016h17",
    transform: "translate(-2016 -5000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_545_copy_2",
    "data-name": "Shape 545 copy 2",
    className: "cls-2",
    d: "M2031.5,5008v17",
    transform: "translate(-2016 -5000)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePlus);
export default __webpack_public_path__ + "static/media/blue_plus.e62a374aca41202866284308347769ea.svg";
export { ForwardRef as ReactComponent };